import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const box = styled.div`
	width: 99.5%;
`;

export const training = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 1rem;

	> img {
		min-width: 15rem;
		max-width: 15rem;
		border-radius: 8px;
		object-fit: 'cover';
		background-color: ${color.interface.darkgray2};
	}

	@media (max-width: 650px) {
		flex-direction: column;
		align-items: center;
	}
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	> p {
		opacity: 0.8;
		font-size: 1.4rem;
		> b {
			font-family: nunito-bold;
		}
	}

	@media (max-width: 650px) {
		align-items: center;
	}

	@media (max-width: 450px) {
		align-items: flex-start;
	}
`;

export const actions = styled.div`
	display: flex;

	> svg {
		margin: 0.5rem;
		font-size: 2.5rem;
		opacity: 0.8;
		cursor: pointer;
	}
`;

export const htmlContent = styled.div`
	display: flex;
	gap: 4px;
	> p {
		opacity: 0.8;
		font-size: 1.4rem;
	}

	> b {
		opacity: 0.8;
		font-size: 1.4rem;
		font-family: nunito-bold;
	}
`;

export const centralizeLoad = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 2rem;
`;

export const emptyList = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 2rem;

	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
		font-family: nunito-bold;
	}
`;
